// extracted by mini-css-extract-plugin
export default {"questionBlock":"Questionnaire_questionBlock__eEuzn"};